class HeaderSearchToggle extends HTMLElement {
  connectedCallback() {
    this.headerSearchEl = this.closest('header-search');

    this.addEventListener('click', () => {
      this.handleClick();
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', () => {
      this.handleClick();
    });
  }

  open() {
    if (window.innerWidth < 1200) {
      return;
    }

    this.headerSearchEl.setAttribute('aria-expanded', 'true');
    let searchInput = this.headerSearchEl.querySelector('input[type="search"]');

    requestAnimationFrame(() => {
      setTimeout(() => {
        searchInput.focus();
      }, 1500);
    });
  }

  close() {
    this.headerSearchEl.setAttribute('aria-expanded', 'false');
  }

  handleClick() {
    // check if mobile menu is open
    let mobileDrawerIsOpen = document.querySelector('.mobile-menu-page.active');
    let megaMenuIsOpen = document.body.classList.contains('megamenu--isActive');

    if (mobileDrawerIsOpen || megaMenuIsOpen) {
      // get closest form element and submit it
      let searchForm = this.closest('header-search').querySelector('form');
      searchForm.submit();
    } else {
      // trigger search drawer to open
      return;
    }
  }
}

window.customElements.define('header-search-toggle', HeaderSearchToggle);
